import styles from './MyLoans.module.css';
import Card from '../../UI/Card';

const MyLoans = props => {
  return (
    <Card>
      <h2 className={styles.title}>My Loans</h2>
      <h3>Coming Soon</h3>
    </Card>
  );
};
export default MyLoans;
